import type { SelectedBrandliveEvent } from '@/types/projects.types';

const evStartMap: Map<SelectedBrandliveEvent, number> = new Map();
export const eventStart = (event: SelectedBrandliveEvent) => {
  const cached = evStartMap.get(event);
  if (cached) return cached;

  let minTimestamp = Infinity;

  for (const session of event.sessions) {
    if (session.timestamp) {
      minTimestamp = Math.min(minTimestamp, session.timestamp);
    }
  }

  evStartMap.set(event, minTimestamp);
  return minTimestamp;
};
